import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files directly for now (we'll add more namespaces later)
import commonEN from './locales/en/common.json';
import commonES from './locales/es/common.json';
import commonFR from './locales/fr/common.json';

const resources = {
  en: {
    common: commonEN
  },
  es: {
    common: commonES
  },
  fr: {
    common: commonFR
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'fr'],
    debug: false,

    ns: ['common'],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false // React already escapes
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'userLanguage'
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
